/*
* Description: Static Application Information
*
* History:
*   06/06/2022  M Smith ITMFG-28835 Initial version, needed because package.json can no longer be read
*
**/
export const appinfo = {
    'name': 'eola',
    'version': '1.0.0'
}